export default __webpack_public_path__ + "static/media/newlayout.04803dc3.jpg";